'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _partial2 = require('lodash/partial');

var _partial3 = _interopRequireDefault(_partial2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // import './FieldHelp.css'
// A simple span that displays help text.
// Optional class added when help is related to an error.


function Help(_ref) {
  var help = _ref.help,
      hasErrors = _ref.hasErrors,
      id = _ref.id,
      suggestion = _ref.suggestion,
      onChange = _ref.onChange;
  var preTxt = 'Do you mean ';
  var postTxt = '? ';
  var className = (0, _classnames2.default)('help-block', {
    'validation-message': hasErrors
  });
  return _react2.default.createElement('p', {
    className: className,
    id: id + '-helpBlock'
  }, suggestion && _react2.default.createElement('span', null, preTxt, _react2.default.createElement('button', {
    onClick: (0, _partial3.default)(onChange, suggestion)
  }, suggestion), postTxt), help);
}

Help.propTypes = {
  help: _propTypes2.default.string.isRequired,
  id: _propTypes2.default.string.isRequired,
  hasErrors: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  suggestion: _propTypes2.default.string
};
exports.default = Help;
module.exports = exports['default'];